<template>
  <Transition>
    <div v-if="isLoadingAnything"></div>
  </Transition>
</template>

<script>
import { mapState } from 'pinia';
import { useLoadingIndicatorStore } from '../store-pinia/loading-indicator';

export default {
  name: 'Loader',
  computed: {
    ...mapState(useLoadingIndicatorStore, ['isLoadingAnything'])
  }
};
</script>

<style lang="scss" scoped>
div {
  @apply h-full w-full absolute flex items-center justify-center bg-center bg-no-repeat;
  z-index: 3000; // Higher than anything Creator-related but lower than MegaMenu
  background-image: url('../assets/icons/loading.svg');
  background-size: 40px;
  background-color: rgba(255, 255, 255, 0.8);
  transition: opacity 0.5s ease;
  opacity: 1;
}
/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
  opacity: 0;
}
</style>
